






































































import { Vue, Component, Watch } from 'vue-property-decorator';
import AddCustomInd from './add-custom-ind.vue';
import AddCustomTable from './add-custom-table.vue';
import AnalyzeCustomServices, { AnalyzeCustomDto } from '@/services/analyzeCustom';
import BaseFormMixin from '@/mixins/base-form-mixin';
import { mixins } from 'vue-class-component';
import { checkCode } from '@/libs/util';
@Component({
  components: { AddCustomInd, AddCustomTable }
})
export default class AddCustom extends mixins(BaseFormMixin) {
  customSrv = new AnalyzeCustomServices();
  formData: AnalyzeCustomDto = {
    boardTool: 0,
    status: 0,
    dataItem: {},
    indicatorInfo: {}
  };

  created() {
    this.onCodeChange();
  }

  @Watch('$route')
  onRouteChange() {
    this.onCodeChange();
  }

  async onCodeChange() {
    let path = this.$route.path;
    if (path == '/analyze/custom/edit') {
      this.formData = {
        dataItem: {},
        indicatorInfo: {}
      };
      let code = this.$route.query.code;
      let info: any = await this.customSrv.getInfo(code);
      this.formData = info;
      this.formData.dataItem = JSON.parse(info.dataItem);
      this.formData.indicatorInfo = JSON.parse(info.indicatorInfo);
    }
  }

  loading: boolean = false;
  async submit() {
    const must: { field: 'boardCode' | 'boardName'; msessage: string }[] = [
      { field: 'boardCode', msessage: '分析看板编码不能为空' },
      { field: 'boardName', msessage: '分析看板名称不能为空' }
    ];
    for (let val of must) {
      if (!this.formData[val.field]) {
        this.$message.error(val.msessage);
        return false;
      }
    }
    if (!this.formData.indicatorInfo?.indicatorInfoList) {
      this.$message.error('请选择分析指标');
      return false;
    }
    // 数据明细非必填写，在选择了主题表后才做数据完整性校验
    if (this.formData.dataItem?.subCode) {
      if (!this.formData.dataItem?.dataField || !this.formData.dataItem?.measureList) {
        this.$message.error('请将数据明细表单补充完整');
        return false;
      }
    }
    if (!checkCode(this.formData.boardCode)) {
      this.$message.error('编码只能包含英文字母、数字、下划线');
      return false;
    }
    if (!this.formData.id) {
      let code = 'ADB_' + this.formData.boardCode;
      let exist = await this.customSrv.getList({ boardCode_eq: code });
      if (exist.length > 0) {
        this.$message.error(`编码[${code}]已经存在`);
        return false;
      }
    }

    this.loading = true;

    if (this.formData.id) {
      let res: any = await this.customSrv.update(this.formData);
      if (res) {
        this.replaceUrlWithOutConfirm('/analyze/custom/detail?code=' + this.formData.boardCode);
        this.formData = {};
      }
    } else {
      let res: any = await this.customSrv.add(this.formData);
      if (res) {
        this.formData = {};
        this.replaceUrlWithOutConfirm('/analyze/custom/detail?code=' + res.boardCode);
      }
    }
    this.loading = false;
  }
}
